import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { PortfolioType } from '@customTypes/portfolio';

type UseGetPortfolioProps = {
  portfolioId: string | null;
};

const useGetPortfolio = ({ portfolioId }: UseGetPortfolioProps) => {
  const [portfolio, setPortfolio] = useState<PortfolioType | null>(null);
  const [loading, setLoading] = useState(true);

  const getPortfolio = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(`/portfolio/${portfolioId}`);
      setPortfolio(response.data);
    } catch (error) {
      toast.error('Erro ao carregar o portfólio. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get portfolio'), {
        error,
        portfolioId,
      });
    } finally {
      setLoading(false);
    }
  }, [portfolioId]);

  useEffect(() => {
    if (portfolioId) {
      getPortfolio();
    }
  }, [getPortfolio, portfolioId]);

  return {
    portfolio,
    loading,
  };
};

export default useGetPortfolio;
